import { number, object, string } from "yup";

export const getValidation = () => {
  const validationSchema = object({
    name: string()
      .required("License Name can’t be blank.")
      .default(""),
    period: string()
      .nullable()
      .required("License Period can’t be blank.")
      .default(null),
    price: number()
      .required("License Price can’t be blank.")
      .nullable()
      .transform(value => (Number.isNaN(value) ? 0 : value))
      .default(null),
    maxNumberOfUsers: number()
      .required("Maximum number of users can’t be blank.")
      .nullable()
      .transform(value => (Number.isNaN(value) ? 0 : value))
      .default(null),
    status: string()
      .nullable()
      .required()
      .default("true")
  });

  return { validationSchema, emptyFormValues: validationSchema.cast({}) };
};
